module.exports = __webpack_public_path__ + "media/src/images/special_feature-487a5c8a26effb26881b54602a42e0b4.svg";